import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  connect() {
    this.element[this.identifier] = this
  }

  move(cardId, position) {
    let data = new FormData()
    data.append("position", position)

    const url = this.data.get("url").replace(":id", cardId)
    const request = new FetchRequest('PATCH', url, { body: JSON.stringify(data), responseKind: 'json' } )
    request.perform()
  }
}
